import { render } from "./IconCanceledByMarlink.vue?vue&type=template&id=38f2a2d7"
import script from "./IconCanceledByMarlink.vue?vue&type=script&lang=js"
export * from "./IconCanceledByMarlink.vue?vue&type=script&lang=js"
script.render = render

export default script